import React from 'react';
import { useRouteMatch } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useTheme } from '@material-ui/core/styles';

import { setPortal } from 'modules/portal';
import { displayFilterList } from 'constants/resources/commonCustomize';
import { makeRowColumn, getHeadObj } from 'lib/commonLib';

import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import Statistics from './Statistics';
import TargetStatistics from './TargetStatistics';
import MediaStatistics from './MediaStatistics';
import TimeStatistics from './TimeStatistics';
import AdverStatistics from './AdverStatistics';

const OpenRTBStatistics = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const { portal } = useSelector(({ portal }) => ({
    portal: portal,
  }));
  let { path } = useRouteMatch();
  const { menu } = useSelector(({ menu }) => ({
    menu: menu.list === null ? new Map() : menu.list,
  }));

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const commonCustomized = {
    BID_ECPM: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'BID_ECPM').label}
            <br />
            {getHeadObj(headsMap, 'WIN_BID_ECPM').label}
            <br />
            {getHeadObj(headsMap, 'ECPM').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BID_ECPM');
        const bodyItem2 = getHeadObj(headsMap, 'WIN_BID_ECPM');
        const bodyItem3 = getHeadObj(headsMap, 'ECPM');
        return (
          <div className="green">
            {makeRowColumn(
              rowObj['BID_ECPM'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(
              rowObj['WIN_BID_ECPM'],
              bodyItem2.type,
              bodyItem2.format
            )}
            <br />
            {makeRowColumn(rowObj['ECPM'], bodyItem3.type, bodyItem3.format)}
          </div>
        );
      },
      orderFlag: false,
    },
    WIN_BID_ECPM: { merged: true },
    ECPM: { merged: true },
    CONV_RATE: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'CONV_RATE').label}
            <br />
            {getHeadObj(headsMap, 'CONV_AMT').label}
            <br />
            {getHeadObj(headsMap, 'AVG_ORDER_AMT').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'CONV_RATE');
        const bodyItem2 = getHeadObj(headsMap, 'CONV_AMT');
        const bodyItem3 = getHeadObj(headsMap, 'AVG_ORDER_AMT');
        return (
          <>
            {makeRowColumn(
              rowObj['CONV_RATE'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            {makeRowColumn(
              rowObj['CONV_AMT'],
              bodyItem2.type,
              bodyItem2.format
            )}
            <br />
            {makeRowColumn(
              rowObj['AVG_ORDER_AMT'],
              bodyItem3.type,
              bodyItem3.format
            )}
          </>
        );
      },
      orderFlag: false,
    },
    CONV_AMT: { merged: true },
    AVG_ORDER_AMT: { merged: true },
    BROWSER_SESSION_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'BROWSER_SESSION_ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'BROWSER_SESSION_ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'BROWSER_SESSION_ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['BROWSER_SESSION_ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            <span style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(
                rowObj['BROWSER_SESSION_ROAS'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </span>
          </>
        );
      },
      orderFlag: false,
    },
    BROWSER_SESSION_ROAS: { merged: true },
    SESSION_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'SESSION_ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'SESSION_ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'SESSION_ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'SESSION_ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['SESSION_ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            <span style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(
                rowObj['SESSION_ROAS'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </span>
          </>
        );
      },
      orderFlag: false,
    },
    SESSION_ROAS: { merged: true },
    DIRECT_ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'DIRECT_ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'DIRECT_ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'DIRECT_ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'DIRECT_ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['DIRECT_ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            <span style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(
                rowObj['DIRECT_ROAS'],
                bodyItem2.type,
                bodyItem2.format
              )}
            </span>
          </>
        );
      },
      orderFlag: false,
    },
    DIRECT_ROAS: { merged: true },
    ORDER_AMT: {
      makeHead: (headsMap) => {
        return (
          <>
            {getHeadObj(headsMap, 'ORDER_AMT').label}
            <br />
            {getHeadObj(headsMap, 'ROAS').label}
          </>
        );
      },
      makeBody: (rowObj, headsMap) => {
        const bodyItem1 = getHeadObj(headsMap, 'ORDER_AMT');
        const bodyItem2 = getHeadObj(headsMap, 'ROAS');
        return (
          <>
            {makeRowColumn(
              rowObj['ORDER_AMT'],
              bodyItem1.type,
              bodyItem1.format
            )}
            <br />
            <span style={{ color: theme.palette.common.purple }}>
              {makeRowColumn(rowObj['ROAS'], bodyItem2.type, bodyItem2.format)}
            </span>
          </>
        );
      },
      orderFlag: false,
    },
    ROAS: { merged: true },
  };

  return (
    <MainTemplate>
      <MbTabs
        name="OpenRTBStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/report/openrtb/day': {
            tabComponent: (
              <Statistics
                displayFilterList={displayFilterList.openRTB}
                handlePortalUrl={handlePortalUrl}
                commonCustomized={commonCustomized}
              />
            ),
          },
          '/report/openrtb/target': {
            tabComponent: (
              <TargetStatistics displayFilterList={displayFilterList.openRTB} />
            ),
          },
          '/report/openrtb/time': {
            tabComponent: (
              <TimeStatistics
                displayFilterList={displayFilterList.openRtbTiime}
                handlePortalUrl={handlePortalUrl}
                commonCustomized={commonCustomized}
              />
            ),
          },
          '/report/openrtb/media': {
            tabComponent: (
              <MediaStatistics
                displayFilterList={displayFilterList.openRTB}
                handlePortalUrl={handlePortalUrl}
                commonCustomized={commonCustomized}
              />
            ),
          },
          '/report/openrtb/adver': {
            tabComponent: (
              <AdverStatistics
                displayFilterList={displayFilterList.openRTB}
                handlePortalUrl={handlePortalUrl}
              />
            ),
            isPop: 1,
          },
          '/mobsense/admin/rtb/kakao_banner.php': { newLink: 1 },
        }}
      />
    </MainTemplate>
  );
};

export default OpenRTBStatistics;
